import React from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router'

import { Box, Tabs, Tab, Divider } from '@material-ui/core'

import TabContext from 'contexts/TabContext'

const TabContainer = ({
  classes,
  history,
  location,
  staticContext,
  orientation,
  children,
  ...rest
}) => {
  const context = React.useContext(TabContext)

  return (
    <Box
      display="flex"
      flexDirection={orientation === 'horizontal' ? 'column' : 'row'}
    >
      <Tabs
        value={context.state.current}
        onChange={context.change}
        orientation={orientation}
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        {...rest}
      >
        {React.Children.toArray(children)
          .filter(tab => tab)
          .map(tab => {
            return (
              <Tab
                value={tab.props.value}
                label={tab.props.label}
                key={tab.props.value}
                disabled={tab.props.hidden}
                data-testid="tab"
              />
            )
          })}
      </Tabs>

      <Box
        mb={orientation === 'horizontal' ? 2 : 0}
        mr={orientation === 'horizontal' ? 0 : 2}
        borderLeft="1px solid #ddd"
      >
        <Divider />
      </Box>

      <Box flex={1}>{children}</Box>
    </Box>
  )
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
}

export default withRouter(TabContainer)
